export default {
  PRESENTIAL_COURSES_FETCHED: 'PRESENTIAL_COURSES_FETCHED',
  PRESENTIAL_COURSES_LOAD: 'PRESENTIAL_COURSES_LOAD',
  PRESENTIAL_COURSES_TEMPLATES_FETCHED: 'PRESENTIAL_COURSES_TEMPLATES_FETCHED',
  PRESENTIAL_COURSES_TEMPLATES_LOAD: 'PRESENTIAL_COURSES_TEMPLATES_LOAD',
  PRESENTIAL_COURSES_DETAIL: 'PRESENTIAL_COURSES_DETAIL',
  PRESENTIAL_COURSES_BUTTON_LOAD: 'PRESENTIAL_COURSES_BUTTON_LOAD',
};
